import type { Vec2 } from '../core/math';
import { PRIM_CAPSULE, PRIM_DISK, PRIM_ROUNDED_BOX, type Primitive } from './sdf/primitives';

export type HandPose = 'relaxed' | 'fist' | 'grip';

/** Chunky palms and a single thumb read at arena scale; the grip point never moves. */
export function handShapes(hand: Vec2, elbow: Vec2, pose: HandPose, side: number, punch = false, sizeScale = 1) {
  const angle = Math.atan2(hand.y - elbow.y, hand.x - elbow.x);
  const c = Math.cos(angle), s = Math.sin(angle), scale = sizeScale * (punch ? 1.18 : 1);
  const point = (x: number, y: number): Vec2 => ({ x: hand.x + (x * c - y * s) * scale, y: hand.y + (x * s + y * c) * scale });
  const line = (ax: number, ay: number, bx: number, by: number, r: number): Primitive => {
    const a = point(ax, ay), b = point(bx, by);
    return { kind: PRIM_CAPSULE, ax: a.x, ay: a.y, bx: b.x, by: b.y, r: r * scale };
  };
  const palm: Primitive = pose === 'relaxed'
    ? line(-0.035, 0, 0.035, 0, 0.087)
    : { kind: PRIM_ROUNDED_BOX, ax: hand.x, ay: hand.y, bx: (pose === 'grip' ? 0.086 : 0.112) * scale, by: 0.103 * scale, r: 0.05 * scale, rot: angle };
  const thumb = point(-0.025, side * (pose === 'relaxed' ? 0.072 : 0.085));
  return {
    palm,
    thumb: { kind: PRIM_DISK, ax: thumb.x, ay: thumb.y, bx: thumb.x, by: thumb.y, r: 0.052 * scale } as Primitive,
    crease: pose === 'relaxed' ? [] : [line(-0.052, side * 0.04, 0.016, side * 0.04, 0.014)],
    angle,
  };
}
